import React from 'react';

export default function GraphmlErrorState({ onRetry }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', height: '60vh', gap: 16, padding: 48,
      textAlign: 'center',
    }}>
      <div style={{ fontSize: 48 }}>⚠️</div>
      <h2 style={{ margin: 0, color: '#1e293b', fontSize: 20, fontWeight: 600 }}>
        Could not check dependency graph status
      </h2>
      <p style={{ margin: 0, color: '#64748b', maxWidth: 420, lineHeight: 1.6 }}>
        There was a problem reaching the server. Please refresh the page or try again.
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            marginTop: 8, padding: '8px 20px', fontSize: 13, fontWeight: 600,
            background: '#0d9488', color: '#fff', border: 'none',
            borderRadius: 8, cursor: 'pointer',
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#0f766e'}
          onMouseLeave={e => e.currentTarget.style.background = '#0d9488'}
        >
          Try again
        </button>
      )}
    </div>
  );
}
